<template>
	<v-container fluid class="mb-16" style="background-color: white;">
		<!-- header -->
		<v-row align="center">
			<v-col cols="8" class="text-left overline" style="font-size: 8px">
				<div>
					CONTROL DE PLAGAS URBANAS Y SERVICIOS GENERALES LTDA.
				</div>
				<div style="font-size: 10px; line-height: 2">
					RUT: 77.025.608-9
				</div>
				<div style="font-size: 10px; line-height: 2">
					Avenida Santa Maria N°0220 OF 2B, Providencia
				</div>
				<div style="font-size: 10px; line-height: 2">
					Fonos contactos: 2752397750
				</div>
				<div style="font-size: 10px; line-height: 2">
					Resolucion Sanitaria N° 020655 del 04-09-2019 SEREMI de Salud Metropolitana
				</div>
				<div style="font-size: 10px; line-height: 2">
					Representante Legal : Sr. Boris Corvalan Donoso
				</div>
				<div style="font-size: 10px; line-height: 2">
					RUT Representante Legal: 11.397.629-2
				</div>
				<div style="font-size: 10px; line-height: 2">
					Representante Legal: Sr. Esteban Gonzalez Ferrada
				</div>
				<div style="font-size: 10px; line-height: 2">
					RUT Representante Legal: 14.344.041-9
				</div>
				<a
					tyle="font-size: 10px; line-height: 2"
					href="https://www.biotecplagas.cl"
					target="_blank"
					style="text-decoration: none"
				>
					www.biotecplagas.cl
				</a>
			</v-col>
			<v-col cols="3">
				<v-img contain src="/img/biotec_logo.png"></v-img>
				<div class="mt-10 text-center">
					<span class="body-2"> Folio N° </span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ order[0] }}</b>
				</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col
				aria-colcount="12"
				class="info text-center white--text headline"
				cols="12"
				v-if="order[33] === 'Si'"
			>
				Certificado de Tratamiento
			</v-col>
			<v-col cols="4">
				<div class="info text-center white--text subtitle-2">
					PROPIETARIO
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 100px"
					>
						NOMBRE
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[6] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 100px"
					>
						RUT
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[7] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 100px"
					>
						DIRECCION
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[8] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 100px"
					>
						COMUNA
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[9] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 100px"
					>
						REGION
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[10] }}
					</div>
				</div>
			</v-col>
			<v-col cols="5" class="pr-0">
				<div class="info text-center white--text subtitle-2">
					FECHA Y VIGENCIA TRATAMIENTO
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 220px"
					>
						TRATAMIENTO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[11] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 220px"
					>
						FECHA TRATAMIENTO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[12] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 220px"
					>
						INICIO TRATAMIENTO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[13] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 220px"
					>
						TERMINO DEL TRATAMIENTO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[14] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 220px"
					>
						VIGENCIA DEL TRATAMIENTO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[15] }}
					</div>
				</div>
			</v-col>
			<v-col cols="3" class="pl-0">
				<div class="info text-center white--text subtitle-2">HORA DEL SERVICIO</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						Hora de inicio
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[16] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						Hora de fin
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[17] }}
					</div>
				</div>
			</v-col>
			<v-col cols="4">
				<div class="info text-center white--text subtitle-2">INMUEBLE TRATADO</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						DIRECCIÓN
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[18] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						COMUNA
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[19] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						REGION
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[20] }}
					</div>
				</div>
				<div class="info text-center white--text subtitle-2 mt-6">TIPO TRATAMIENTO</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						DESRATIZADO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[21] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						SANITIZACION
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[22] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						DESINSECTADO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[23] }}
					</div>
				</div>
			</v-col>
			<v-col cols="6">
				<div class="info text-center white--text subtitle-2">
					SOLICITUD DEL TRATAMIENTO
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						NOMBRE
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[24] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						RUT
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[25] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						TELEFONO
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[26] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						DIRECCIÓN
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[27] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						COMUNA
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[28] }}
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div
						class="info--text font-weight-bold text-left ml-2"
						style="min-width: 150px"
					>
						REGION
					</div>
					<v-divider vertical></v-divider>
					<div class="text-left body-1 ml-2" style="width: 100%">
						{{ order[29] }}
					</div>
				</div>
			</v-col>
			<v-col cols="6">
				<v-simple-table dense>
					<template v-slot:default>
						<thead class="info">
							<tr>
								<th
									class="text-center white--text"
									colspan="3"
									style="border-right: 1px solid #C8E6C9"
								>
									LUGAR TRATADO
								</th>
								<th
									class="text-center white--text"
									colspan="2"
									style="border: 1px solid #C8E6C9"
								>
									SECTOR
								</th>
								<th
									class="text-center white--text"
									colspan="4"
									style="border: 1px solid #C8E6C9"
								>
									SERVICIOS
								</th>
							</tr>
							<tr>
								<th colspan="3" style="border-right: 1px solid #C8E6C9"></th>
								<th
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									Int
								</th>
								<th
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									Ext
								</th>
								<th
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									DR
								</th>
								<th
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									DS
								</th>
								<th
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									SN
								</th>
								<th
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									O
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, i) in order[30]" :key="i">
								<td colspan="3">
									{{ order[30][i].name }}
								</td>
								<td>
									{{ order[30][i].int ? 'Si' : 'No' }}
								</td>
								<td>
									{{ order[30][i].ext ? 'Si' : 'No' }}
								</td>
								<td>
									{{ order[30][i].dr ? 'Si' : 'No' }}
								</td>
								<td>
									{{ order[30][i].ds ? 'Si' : 'No' }}
								</td>
								<td>
									{{ order[30][i].sn ? 'Si' : 'No' }}
								</td>
								<td>
									{{ order[30][i].o ? 'Si' : 'No' }}
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-col>
			<v-col>
				<div class="info text-center white--text subtitle-2">RECOMENDACIONES</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="text--secondary font-weight-bold text-left ml-2">
						Se recomineda limpieza profunda de rejillas de los desagües.
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="text--secondary font-weight-bold text-left ml-2">
						No dejar pozas de agua que se fermenten
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="text--secondary font-weight-bold text-left ml-2">
						No dejar mopa mojada y carro con agua
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="text--secondary font-weight-bold text-left ml-2">
						Tratar camara de desagüe con bioenzimas
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="text--secondary font-weight-bold text-left ml-2">
						Cambiar rejilla metalica de panaderia por plasticas
					</div>
				</div>
				<div class="info text-center white--text subtitle-2 mt-6">OBSERVACIONES</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="caption font-weight-bold text-left ml-2">
						1° Mantener cerrado los lugares de tratamiento por un tiempo minimo de dos
						horas
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="font-weight-bold caption text-left ml-2">
						2° Pasado el tiempo de cierre ingresar abrir puertas, ventanas y salir.
						Dejar ventilar por una hora minimo.
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="font-weight-bold caption text-left ml-2">
						3° Reingresar después de ventilar, si al ingresar percibe olor de
						insecticida volver a salir y dejar ventilar mas tiempo.
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="font-weight-bold caption text-left ml-2">
						4° Si es posible, no mojar paredes y pisos por 48 horas
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="font-weight-bold caption text-left ml-2">
						5° Limpiar superficies de escritorios y articulo que hubiese quedado
						expuestos a la desinsectacion sillas y mesas
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="font-weight-bold caption text-left ml-2">
						6 Limpiar usando guantes de látex y mascarilla de papel y paño humedo
						constantemen te enguajado Se recambian laminas pegajosas de las Lamparas
					</div>
				</div>
				<div
					class="d-flex justify-space-between align-center"
					style="border: 1px solid gray"
				>
					<div class="font-weight-bold text-center ml-2">
						CONSULTAS LLAMAR AL: +56 9 9638 3844
					</div>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="info text-center white--text">
					<span class="mx-2">Int: Interior</span>
					<span class="mx-2">Ext: Exterior</span>
					<span class="mx-2">DR: Desratización</span>
					<span class="mx-2">DS: Desinsectaciones</span>
					<span class="mx-2">SN: Sanitización</span>
				</div>
				<div class="info title text-center white--text">
					PLAGUICIDA
				</div>
				<v-simple-table dense>
					<template v-slot:default>
						<thead class="info">
							<tr>
								<th
									class="text-center white--text"
									colspan="2"
									style="border: 1px solid #C8E6C9"
								>
									Nombre comercial y Formulacion
								</th>
								<th
									colspan="1"
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									Ingrediente activo
								</th>
								<th
									colspan="1"
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									Metodologuia o Tipo de Control
								</th>
								<th
									colspan="1"
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									RES ISP N°
								</th>
								<th
									colspan="1"
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									Dosis, N° y Peso de los Puntos de Control
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, i) in order[31]" :key="i">
								<td colspan="2">
									{{ order[31][i].formulacion }}
								</td>
								<td colspan="1">
									{{ order[31][i].ingredienteActivo }}
								</td>
								<td colspan="1">
									{{ order[31][i].metodologia }}
								</td>
								<td colspan="1">
									{{ order[31][i].isp }}
								</td>
								<td colspan="1">
									{{ order[31][i].dosis }}
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
				<v-simple-table dense>
					<template v-slot:default>
						<thead class="info">
							<tr>
								<th
									class="text-center white--text"
									colspan="2"
									style="border: 1px solid #C8E6C9"
								>
									ESPECIE A CONTROLAR
								</th>
								<th style="border: 1px solid #C8E6C9" class="text-center title">
									X
								</th>
								<th
									colspan="1"
									class="text-center white--text"
									style="border: 1px solid #C8E6C9"
								>
									IDENTIFICACION ESPECIE
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, i) in order[32]" :key="i">
								<td colspan="2">
									{{ order[32][i].especie }}
								</td>
								<td class="text-center">
									{{ order[32][i].boolean ? 'x' : '' }}
								</td>
								<td colspan="1">
									{{ order[32][i].identificacion }}
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-col>
		</v-row>
		<v-row>
			<div class="template" v-if="order[33] === 'Si'">
				<template>
					<v-col cols="12">Firma</v-col>
					<v-img contain src="@/assets/firma-biotec.png" alt="" max-width="500" />
					<v-col cols="12">
						Esteban A Gonzalez Ferrada
					</v-col>
				</template>
			</div>
		</v-row>
		<v-row>
			<template v-if="images">
				<v-col cols="12">
					Antecedentes fotográficos:
				</v-col>
				<div v-for="(img, key) in images" :key="key" class="d-flex child-flex ">
					<v-img
						v-if="isToday(order[1], img.createAt)"
						lazy-src="@/assets/placeholder.png"
						:src="img.url"
						max-height="200px"
						max-width="200px"
						class="mr-1 mb-1"
						style="border-radius: 15px;"
						alt="imagen de la orden"
					>
						<div class="bg caption text-right" v-if="img.createdAt">
							{{ createAt(img.createdAt) }}
						</div>
					</v-img>
					<div
						class="mr-1 mb-1 pl-2 pt-2"
						style="border-radius: 15px; height: 100px; width: 200px; border: 1px solid black;"
						v-else
					>
						Existe una foto tomada: {{ createAt(img.createdAt) }}
					</div>
				</div>
			</template>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	props: {
		workOrder: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			idLodging: undefined,
			indexWorkOrder: undefined,
			order: [],
			place: '',
			images: [],
		};
	},
	computed: {
		dateTime() {
			return moment(this.order[79]).format('lll');
		},
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		workOrder() {
			this.order = this.workOrder;
		},
	},
	created() {
		if (!this.$vuetify.breakpoint.lgAndUp)
			document.getElementById('viewport').setAttribute('content', 'width=900');
	},
	mounted() {
		this.idLodging = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		if (this.workOrder) {
			this.order = this.formatWorkOrder(this.workOrder);
			this.place = this.lodgingSelect.place;
			if (this.lodgingSelect.documents) {
				const documents = this.lodgingSelect.documents;
				this.images = documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			}
		} else if (this.idLodging && this.indexWorkOrder)
			this.getWorkOrder({
				idLodging: this.idLodging,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = this.formatWorkOrder(data.workOrder);
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
	},
	methods: {
		isToday(orderDate, datePhoto) {
			return moment(orderDate).isSame(datePhoto, 'day');
		},
		createAt(date) {
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},
		hasInfo(item) {
			return item !== 'Sin info';
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'Sin info';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
		}),
	},
};
</script>

<style scoped>
.bg {
	background-color: rgba(255, 255, 255, 0.5);
}
</style>
